/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { DotNavigation, DotsNavigationContent, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface IDotNavigationEditorProps { 
   item: DotsNavigationContent
}
const DotNavigationEditor = (props: IDotNavigationEditorProps): JSX.Element => {
    const currentLanding            = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const isEdit                    = useLandingStore( (state: ILandingStore) => state.isEdit )
    const [sections, setsSections]  = useState<ILandingSection[]>(currentLanding.sections)
    const [items, setItems]         = useState<DotNavigation[]>(props.item.items)

    useEffect(() => {
        if(!isEdit) return
         const unsubscribe = useLandingStore.subscribe(
                ( state: ILandingStore ) => state.currentLanding,
                ( currentLanding:ILanding ) => {  
                    const anchors       = sections.map(it => it.id)
                    const newIndex      = currentLanding.sections.findIndex(section => !anchors.includes(section.id) )
                    let newItemIndex    = 0
                    currentLanding.sections.forEach((s, i) => {
                        if( i <= newIndex ) {
                            items.find(item => s.id === item.anchor)
                        }
                    })
                }, 
                {} 
            ) 
            return () => {
                unsubscribe();
            };
    }, [])

    return <div className='pe-dot-navigation-editor-container'>
       
    </div>
}
export default DotNavigationEditor